const config = {
    basePath: process.env.REACT_APP_OFFLINE === 'true' ?
        `http://${process.env.REACT_APP_API_DOMAIN_OFFLINE}/admin` :
        `https://${process.env.REACT_APP_API_DOMAIN}/v1/admin`,
    clientId: process.env.REACT_APP_OFFLINE === 'true' ?
        process.env.REACT_APP_ADMIN_CLIENT_OFFLINE :
        process.env.REACT_APP_ADMIN_CLIENT,
    accessToken: '@token',
    refreshToken: '@refreshToken',
    appDomainMask: process.env.REACT_APP_APP_DOMAIN,
    accountCreditLimit: parseInt(process.env.REACT_APP_CREDIT_ACCOUNT_LIMIT ?? 0),
    featureFlags: {
        assessmentIsEnabled: process.env.REACT_APP_ASSESSMENT_FEATURE_FLAG === 'on',
        aiCostsDashboard: process.env.REACT_APP_AI_COSTS_DASHBOARD_FEATURE_FLAG === 'on',
    },
};

export default config;
